import axios from 'axios';
import {Modal} from '@enos/dpl';
import {STATUS_CODE} from './constant';
import RequestStore from '~/stores/request';
import localeText from '@locale';

const handleError = (data, {title, content, onOk}) => {
  Modal.error({
    title: title || localeText('COMMON.TITLE_WRONG_MESSAGE'),
    content: content || data.message,
    onOk: () => {
      if (typeof onOk === 'function') {
        onOk();
      }
    },
    zIndex: 10000
  });
};

const axiosInstance = axios.create({
  // Configure default configuration when creating an instance
  // baseURL: '/app-portal/web/v1/',
  timeout: 1000 * 60 * 3,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const {data} = response;

    // success
    if (data.code === STATUS_CODE.SUCCESS || data.code === undefined) {
      return Promise.resolve(data.data);
    }

    // Not logged in, pop up the login prompt box, click confirm to jump to the app portal login page
    if (data.code === STATUS_CODE.UNAUTHENTICATED) {
      handleError(data, {
        onOk: () => {
          RequestStore.login();
        }
      });
      return Promise.reject(data);
    }

    // Failure, such as failed verification, etc
    handleError(response);
    return Promise.reject(response);
  },

  // System errors, such as 500, 404, etc
  error => {
    handleError(error.response.data, {});
    return Promise.reject(error.response);
  }
);

export default axiosInstance;
